import { render, staticRenderFns } from "./portal.view.vue?vue&type=template&id=684bf1ce&scoped=true&"
import script from "./portal.view.ts?vue&type=script&lang=ts&"
export * from "./portal.view.ts?vue&type=script&lang=ts&"
import style0 from "./portal.view.scss?vue&type=style&index=0&id=684bf1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684bf1ce",
  null
  
)

export default component.exports